import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { BaseOfferBlock } from '../blocks.types'

export const BrandOfferListBlockFragment: BlockFragment = {
  name: 'brandOfferList',
  fragment: gql`
    fragment brandOfferList on BrandOfferList {
      id
      blockName
      blockType
      offers {
        id
        name
        tag
        description
        thumbnailImage {
          id
          url
          alt
        }
        featuredImage {
          id
          url
          alt
        }
        brand {
          id
          slug
          logo {
            id
            url
            alt
          }
        }
        slug
        expiresAt
        offerLinkLabel
        offerLink
        offerLinkLabel
        redeemInList
        usesCodes
        canRedeem
      }
      limit
      title
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ... on BrandOfferList {
      id
      blockName
      blockType
      offers {
        id
        name
        tag
        description
        thumbnailImage {
          id
          url
          alt
        }
        featuredImage {
          id
          url
          alt
        }
        brand {
          id
          slug
          logo {
            id
            url
            alt
          }
        }
        slug
        expiresAt
        offerLinkLabel
        offerLink
        offerLinkLabel
        redeemInList
        usesCodes
        canRedeem
      }
      limit
      title
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}
export const BrandOfferListBlockType = 'brandOfferList'

export const canRenderBrandOfferListBlock = (block: BrandOfferListBlock): boolean => {
  if (!block.offers || block.offers.length === 0) {
    return false
  }

  return true
}

export interface BrandOfferListBlock extends BaseOfferBlock {
  blockType: typeof BrandOfferListBlockType

  offers: {
    id: string
    name: string
    thumbnailImage: {
      url: string
      alt: string
    }
    featuredImage: {
      url: string
      alt: string
    }
    slug: string
    description?: string
    tag?: string
    brand: {
      slug: string
      logo: {
        url: string
        alt: string
      }
    }
    expiresAt: any
    redeemInList?: boolean
    canRedeem?: boolean
    offerLinkLabel?: string
    usesCodes?: boolean
  }[]
  limit: number
  title?: string
}
